<template>
  <div class="content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="content__box">
          <div class="content__box__header">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <ul class="top__filter__ul">
                <li
                  :class="{ active: tab === 'operator' }"
                  @click="changeTab('operator')"
                >
                  Operators
                </li>
                <li
                  :class="{ active: tab === 'inviteOperator' }"
                  @click="changeTab('inviteOperator')"
                >
                  Invited Users
                </li>
              </ul>

              <div class="d-flex align-items-center">
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer"
                  @click="openCreateOperatorModal()"
                >
                  + Add Operators
                </p>
              </div>
            </div>
          </div>
          <div class="content__divider"></div>
          <div
            class="content__box__body content__box__body__audit__table"
          >
            <div class="table-responsive">
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th v-if="tab=='operator'">Name</th>
                    <th>Email</th>
                    <th>Property Access</th>
                    <th>Report Access</th>
                    <!-- <th>Audit Access</th> -->
                    <th>Permit Access</th>
                    <th>Invitation Access</th>
                    <th>Validation Access</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="operator_list.length > 0">
                  <tr v-for="(operator, index) in operator_list" :key="index">
                    <td v-if="tab=='operator'"> 
                      {{ operator.operator_name}}
                    </td>
                    <td>{{ operator.email }}</td>
                    <td>
                      {{
                        operator.access_permissions.all_property_access
                          ? "All Property"
                          : getPropertyAccess(operator.access_permissions.property_access_list)
                      }}
                    </td>
                    <td
                      :class="[
                        operator.access_permissions.report_access
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      {{
                        operator.access_permissions.report_access ? "Granted" : "Restricted"
                      }}
                    </td>
                    <!-- <td
                      :class="[
                        operator.access_permissions.audit_access ? 'txt--green' : 'txt--red',
                      ]"
                    >
                      {{ operator.access_permissions.audit_access ? "Granted" : "Restricted" }}
                    </td> -->
                    <td
                      :class="[
                        operator.access_permissions.permit_access
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      {{
                        operator.access_permissions.permit_access ? "Granted" : "Restricted"
                      }}
                    </td>
                    <td
                      :class="[
                        operator.access_permissions.invitation_access
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      {{
                        operator.access_permissions.invitation_access ? "Granted" : "Restricted"
                      }}
                    </td>
                     <td
                      :class="[
                        operator.access_permissions.validation_access
                          ? 'txt--green'
                          : 'txt--red',
                      ]"
                    >
                      {{
                        operator.access_permissions.validation_access ? "Granted" : "Restricted"
                      }}
                    </td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        class="txt--green mr-2"
                        @click="openUpdateOperatorModal(operator)"
                        >Edit</a
                      >
                      <a
                        href="javascript:void(0);"
                        class="txt--red"
                        @click="deleteOperator(operator.id)"
                        >Delete</a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td :colspan="tab=='operator'? 8:7"> <p class="txt--ss d-flex justify-content-center">No Data Found</p></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CreateOperator @create_operator_list="resetData('inviteOperator')" />
    <UpdateOperator @update_operator_list="resetData()" />
  </div>
</template>
<script>
import CreateOperator from "@/components/modals/CreateOperator";
import UpdateOperator from "@/components/modals/UpdateOperator";
export default {
  name: "OperatorManagement",
  components: {
    CreateOperator,
    UpdateOperator,
  },
  data() {
    return {
      tab: "operator",
      property_list: [],
      operator_list: [],
    };
  },
  created() {
    this.getProperties();
    this.getOperators();
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
      this.getOperators();
    },
    resetData(tab=null) {
      if(tab!=null) {
        this.tab = tab;
      }
      this.property_list = [];
      this.operator_list = [];
      this.getProperties();
      this.getOperators();
    },
    getProperties() {
      this.axios
        .post(window.hostname + "api/auth/all-space", {
          limit: 500,
          device_type: 1,
          space_type: 1,
          status: 0,
          page: 1,
          minify: 1,
          minify_2: 0,
          time_zone: this.$moment.tz.guess(new Date()),
        })
        .then((res) => {
          if (res.data.status) {
            this.property_list = res.data.data.all_space;
          } else {
            this.property_list = [];
          }
        })
        .catch((err) => {
          console.log(err);
          this.property_list = [];
        });
    },
    getPropertyAccess(property_access) {
      if (property_access.length > 0) {
        let property_name_array = property_access.map((val) => {
          return val.property_name;
        });

        return property_name_array.join(",");
      } else {
        return "Restricted";
      }
    },
    getOperators() {
      this.axios
        .post(window.hostname + "/api/auth/operator/list", {
          claim: this.tab=='operator' ? 1 : 0,
        })
        .then((res) => {
          if (res.data.status) {
            this.operator_list = res.data.data;
          } else {
            this.operator_list = [];
          }
        })
        .catch((err) => {
          this.operator_list = [];
        });
    },
    openCreateOperatorModal() {
      this.$modal.show("create-operator-modal", {
        property_list: this.property_list,
      });
    },
    openUpdateOperatorModal(operator) {
      // console.log(operator);
      this.$modal.show("update-operator-modal", {
        operator: JSON.parse(JSON.stringify(operator)),
        tab: this.tab,
        property_list: JSON.parse(JSON.stringify(this.property_list)),
      });
    },
    deleteOperator(operator_id) {
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this operator?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "/api/auth/operator/remove", {
              id: operator_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.resetData(this.tab);
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
  },
};
</script>